import React, { useEffect, useState } from 'react';
import { Menu, X, Car } from 'lucide-react';
import { Button } from '../ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
interface HeaderProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}
export function Header({
  currentPage,
  onNavigate
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Start',
    value: 'home'
  }, {
    name: 'Produkt',
    value: 'product'
  }, {
    name: 'Lösungen',
    value: 'solutions'
  }, {
    name: 'Unternehmen',
    value: 'company'
  }, {
    name: 'Kontakt',
    value: 'contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0a0a0f]/90 backdrop-blur-md border-b border-gray-800 py-3' : 'bg-transparent py-5'}`} data-id="element-55">
      <div className="container mx-auto px-4 md:px-6" data-id="element-56">
        <div className="flex items-center justify-between" data-id="element-57">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => onNavigate('home')} data-id="element-58">
            <div className="w-10 h-10 bg-cyan-500 rounded-lg flex items-center justify-center" data-id="element-59">
              <Car className="text-black w-6 h-6" data-id="element-60" />
            </div>
            <span className="text-xl font-bold tracking-tight text-white" data-id="element-61">
              TIKA <span className="text-cyan-400" data-id="element-62">Mobility</span>
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-63">
            {navLinks.map(link => <button key={link.value} onClick={() => onNavigate(link.value)} className={`text-sm font-medium transition-colors hover:text-cyan-400 ${currentPage === link.value ? 'text-cyan-400' : 'text-gray-300'}`} data-id="element-64">
                {link.name}
              </button>)}
          </nav>

          {/* CTA & Mobile Toggle */}
          <div className="flex items-center gap-4" data-id="element-65">
            <div className="hidden md:block" data-id="element-66">
              <Button variant="primary" size="sm" onClick={() => onNavigate('contact')} data-id="element-67">
                Demo anfragen
              </Button>
            </div>

            <button className="md:hidden text-gray-300 hover:text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-68">
              {isMobileMenuOpen ? <X data-id="element-69" /> : <Menu data-id="element-70" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-71">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#0a0a0f] border-b border-gray-800 overflow-hidden" data-id="element-72">
            <div className="container mx-auto px-4 py-6 flex flex-col gap-4" data-id="element-73">
              {navLinks.map(link => <button key={link.value} onClick={() => {
            onNavigate(link.value);
            setIsMobileMenuOpen(false);
          }} className={`text-left text-lg font-medium py-2 ${currentPage === link.value ? 'text-cyan-400' : 'text-gray-300'}`} data-id="element-74">
                  {link.name}
                </button>)}
              <Button variant="primary" className="w-full mt-4" onClick={() => {
            onNavigate('contact');
            setIsMobileMenuOpen(false);
          }} data-id="element-75">
                Demo anfragen
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}